import { render } from "./ItemRewards.vue?vue&type=template&id=1baa7306"
import script from "./ItemRewards.vue?vue&type=script&lang=js"
export * from "./ItemRewards.vue?vue&type=script&lang=js"

import "./ItemRewards.vue?vue&type=style&index=0&id=1baa7306&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__